// extracted by mini-css-extract-plugin
export default {"adminPage":"adminPage","panel":"panel"};